<template>
  <base-text
    class="cursor-pointer d-flex align-items-center"
    nowrap
    :size="size"
    light
    text
    @click.native.prevent="$emit('click')"
  >
    <base-icon
      :icon="icon"
      class="mr-2"
      :class="{'icon-small': small}"
    />
    <slot>New</slot>
  </base-text>
</template>

<script>
export default {
  name: 'BaseLinkWithIcon',
  props: {
    icon: {
      type: String,
      default: 'plus',
    },
    size: {
      type: String,
      default: 's',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};

</script>

<style lang="scss" scoped>
.icon-small{
  max-width: 13px;
}
</style>
